import {FC} from 'react'
import {connect} from 'react-redux'
import {EmployeeDependent} from 'types/api/employees/employeeDependent'
import {YearStyleType} from 'libs/formatter'
import {Dependent} from './Dependent'
import styles from './Parts.scss'

import type {State} from 'types/state'

// @ts-ignore
import {Panel, Item} from 'components/PrimaryPanel'
// @ts-ignore
import {HeaddingWithLink} from './utils'
// @ts-ignore
import {Grid} from './Parts'

interface EmployeeDependentsProps {
  dependents: EmployeeDependent[]
  yearStyle: YearStyleType
  editLink: string
  canEdit: boolean
}

const renderEmployeeDependents: FC<EmployeeDependentsProps> = ({dependents, yearStyle, editLink, canEdit}) => (
  <Panel>
    <HeaddingWithLink to={`${editLink}#Dependent`} title="家族情報" canEdit={canEdit} />
    <Item>
      {dependents.length > 0 ? (
        <Grid className={styles.fixedTwoColumns}>
          {dependents.map((dependent, index) => (
            <Dependent key={dependent.id} dependent={dependent} index={index} yearStyle={yearStyle} />
          ))}
        </Grid>
      ) : (
        <div className={styles.noData}>
          <p>家族情報の登録はありません</p>
        </div>
      )}
    </Item>
  </Panel>
)

export const EmployeeDependents = connect((state: State) => ({
  dependents: state.employees.current.data.employee_dependents || [],
}))(renderEmployeeDependents)
